import React from 'react'
import { StyledOnlineBadge, StyledOfflineBadge } from '../../styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const CheckOnlineOffline = (props) => {
  const {
    online,
    children,
    className,
    style,
    onlineClass,
    offlineClass,
    ...rest
  } = props
  return online ? (
    <StyledOnlineBadge
      overlap="circular"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      variant="dot"
      className={clsx(className, onlineClass)}
      style={style}
      {...rest}>
      {children}
    </StyledOnlineBadge>
  ) : (
    <StyledOfflineBadge
      overlap="circular"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      variant="dot"
      className={clsx(className, offlineClass)}
      style={style}
      {...rest}>
      {children}
    </StyledOfflineBadge>
  )
}

CheckOnlineOffline.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  online: PropTypes.bool,
  classes: PropTypes.string
}

CheckOnlineOffline.displayName = 'coo'

export default CheckOnlineOffline
